import React from 'react';
import { Container, Typography, Box, Grid2 as Grid } from '@mui/material';
import Footer from "../layout/Footer";

const AcercaDe = () => {
  return (
    <>
      {/* Hero Section */}
      <Box className="header-container">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Grid container size={12} sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="h1" component="h1" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              Acerca de OneService
            </Typography>
          </Grid>
        </Container>
      </Box >

      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography variant="body1" paragraph sx={{ mt: 2, fontSize: '1.1rem', lineHeight: 1.8 }}>
          OneService es una plataforma tecnológica mexicana creada para profesionalizar el mercado de servicios y facilitar conexiones seguras entre personas y prestadores independientes.
        </Typography>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
          Nuestra misión es generar confianza, transparencia y eficiencia en la contratación de servicios locales.
        </Typography>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
          Actuamos como intermediarios tecnológicos, impulsando oportunidades económicas y elevando estándares de calidad en el mercado.
        </Typography>
      </Container>
      <Footer />
    </>
  );
};

export default AcercaDe;
